// Learner App does not support translation (see /learnerApp/src/App.tsx)
/* eslint-disable i18next/no-literal-string */
import { useEffect, useRef, useState } from "react";

const LOADING_BUTTON_TEXT_OPTIONS = [
  "Mixing...",
  "Spinning...",
  "Combining...",
  "Blending...",
  "Merging...",
  "Fusing...",
  "Melding...",
  "Mingling...",
  "Integrating...",
  "Synthesizing...",
  "Amalgamating...",
  "Unifying...",
  "Splicing...",
] as const;
const LOADING_BUTTON_TEXT_CYCLE_INTERVAL_MS = 1000;

export default function useLoadingButtonText(shouldAnimate: boolean) {
  const [index, setIndex] = useState(0);
  const shuffledTextOptions = useRef<string[]>(
    shuffleArray(LOADING_BUTTON_TEXT_OPTIONS),
  );

  useEffect(() => {
    if (!shouldAnimate) {
      setIndex(0);
      shuffledTextOptions.current = shuffleArray(LOADING_BUTTON_TEXT_OPTIONS);
      return;
    }

    const interval = setInterval(() => {
      setIndex(prev => {
        const nextIndex = (prev + 1) % shuffledTextOptions.current.length;
        if (nextIndex === 0) {
          shuffledTextOptions.current = shuffleArray(
            LOADING_BUTTON_TEXT_OPTIONS,
          );
        }
        return nextIndex;
      });
    }, LOADING_BUTTON_TEXT_CYCLE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [shouldAnimate]);

  return shuffledTextOptions.current[index];
}

// Shuffle array elements using Durstenfeld shuffle algorithm (optimized Fischer-Yates)
function shuffleArray(array: readonly string[]): string[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
